import { render, staticRenderFns } from "./setting-switch.vue?vue&type=template&id=33d9ef22&"
import script from "./setting-switch.vue?vue&type=script&lang=js&"
export * from "./setting-switch.vue?vue&type=script&lang=js&"
import style0 from "./setting-switch.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports